import EmptyResultsContainer from './EmptyResultsContainer';

export default EmptyResultsContainer;
